$( document ).ready(() => {

	$( document ).on({
		mouseenter: ( e ) => {
			var parent = e.currentTarget.getAttribute('data-parent');
			var target = $( e.currentTarget ).parents( parent )[0]
			$( target ).find('.animate-link').addClass('hover')
		},
		mouseleave: ( e ) => {
			var parent = e.currentTarget.getAttribute('data-parent');
			var target = $( e.currentTarget ).parents( parent )[0]
			$( target ).find('.animate-link').removeClass('hover')
		}
	}, '.animate-image' );

	$( document ).on({
		mouseenter: ( e ) => {
			var parent = e.currentTarget.getAttribute('data-parent');
			var target = $( e.currentTarget ).parents( parent )[0]
			$( target ).find('.animate-image').addClass('hover')
		},
		mouseleave: ( e ) => {
			var parent = e.currentTarget.getAttribute('data-parent');
			var target = $( e.currentTarget ).parents( parent )[0]
			$( target ).find('.animate-image').removeClass('hover')
		}
	}, '.animate-link' );

})


// WEBPACK FOOTER //
// ./assets/js/components/animate-image-on-link-hover.js